// Libraries
import {Navigate, Route, Routes} from 'react-router-dom';
import {useSelector} from 'react-redux';
import {Layout} from 'antd';
import { useTranslation } from 'react-i18next';

// Store
import * as sessionSelectors from '../../store/redux/selectors/sessionSelectors';

// Components
import Login from "../session/Login";
import Users from "../users/Users";
import Alliances from "../alliances/Alliances";
import Catalog from "../catalog/Catalog";
import ProductDetail from "../catalog/ProductDetail";
import Stores from '../stores/Stores';
import Categories from '../categories/Categories';
import Orders from '../orders/Orders';

// Constants and Functions
import {routes} from '../../utils/routes';
const {Content} = Layout;

function Router() {
  const { t } = useTranslation();
  const isLoggedIn = useSelector(sessionSelectors.isLoggedInSelector);

  return (
    <Content className={`flex flex-col w-0 flex-1 overflow-hidden min-h-screen ${isLoggedIn ? 'py-6 px-8' : ''}`}>
      <Routes>
        {isLoggedIn
          ?
          <>
            <Route path={routes(t).users} element={<Users />} />
            <Route path={routes(t).alliances} element={<Alliances />} />
            <Route path={routes(t).catalog.root} element={<Catalog />} />
            <Route path={routes(t).catalog.detail} element={<ProductDetail />} />
            <Route path={routes(t).stores} element={<Stores />} />
            <Route path={routes(t).categories} element={<Categories />} />
            {/*
              <Route path={routes(t).orders.root} element={<Orders />} />
              <Route path={routes(t).orders.orders} element={<Orders />} />
              <Route path={routes(t).orders.payments} element={<Orders />} />
              <Route path={routes(t).orders.shipments} element={<Orders />} />
            */}

            <Route path={'*'} element={<Navigate to={routes(t).users} />} />
          </>
          :
          <>
            <Route path={routes(t).session.login} element={<Login />} />
            <Route path={routes(t).session.authentication} element={<Login />} />

            <Route path={'*'} element={<Navigate to={routes(t).session.login} />} />
          </>
        }
      </Routes>
    </Content>
  );
}

export default Router;
